import { css } from "@emotion/react";

export const textLeft = css`
  text-align: left;
`;
